<template lang="pug">
    .card-display
        a(:href="data.url")
            .crop.card-image(
              :style="({'background-image': `url(${data.content.image})`})"
            )
              img(src="/static/images/1x1.gif" class="full-width")
        div
            a(:href="`/${data.url}`" target="_blank")
                h3 {{ data.content.title }}
            p(v-html="data.content.snippet")

</template>


<script>
    export default {
        name: 'card',
        props: ['data']
    }
</script>


<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/BottomCardDisplay.vue